import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  seoListData,
  setGetById,
  updateSeohome,
} from "../../../redux/seo/action";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import { seoHomeValidation } from "../../Constant/constant";

const SeoHome = () => {
  const id = 1;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const seoHome = useSelector((state) => state?.reusableSlice?.seoHome);

  useEffect(() => {
    if (id) {
      dispatch(setGetById(id));
    }
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      h1: seoHome?.h1 || "",
      h2: seoHome?.h2 || "",
      ar_h1: seoHome?.ar_h1 || "",
      ar_h2: seoHome?.ar_h2 || "",
      canonical: seoHome?.canonical || "",
      ar_canonical: seoHome?.ar_canonical || "",
      meta_title: seoHome?.meta_title || "",
      ar_meta_title: seoHome?.ar_meta_title || "",
      meta_description: seoHome?.meta_description || "",
      ar_meta_description: seoHome?.ar_meta_description || "",
      keywords:seoHome?.keywords||"",
      ar_keywords:seoHome?.ar_keywords||"",
      id: seoHome?.id || "",
    },

    validationSchema: seoHomeValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    try {
      const data = {
        ...values,
      };
      dispatch(updateSeohome(data, setLoading, navigate));
    } catch (error) {
      console.error("Submit Error:", error);
    }
  };
  return (
    <div className="px-4 pb-3 pt-5">
      <div className=" category-wrapper">
        <h1>Home</h1>
        <form onSubmit={formik.handleSubmit}>
        <div className="col-md-12  description-add">
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Heading 1</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter h1"
              name="h1"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.h1}
            />
            {formik.touched.h1 && formik.errors.h1 ? (
              <div className="error">{formik.errors.h1}</div>
            ) : null}
          </div>
          <div className="col-md-6 form-group">
            <label>Heading 2</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter h2"
              name="h2"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.h2}
            />
            {formik.touched.h2 && formik.errors.h2 ? (
              <div className="error">{formik.errors.h2}</div>
            ) : null}
          </div>
          <div className="col-md-6 form-group">
            <label>Arabic Heading 1</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter arabic h1"
              name="ar_h1"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.ar_h1}
            />
            {formik.touched.ar_h1 && formik.errors.ar_h1 ? (
              <div className="error">{formik.errors.ar_h1}</div>
            ) : null}
          </div>
          <div className="col-md-6 form-group">
            <label>Arabic Heading 2</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter arabic h2"
              name="ar_h2"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.ar_h2}
            />
            {formik.touched.ar_h2 && formik.errors.ar_h2 ? (
              <div className="error">{formik.errors.ar_h2}</div>
            ) : null}
          </div>
          <div className="col-md-6 form-group">
            <label>Canonical</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter canonical"
              name="canonical"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.canonical}
            />
            {formik.touched.canonical && formik.errors.canonical ? (
              <div className="error">{formik.errors.canonical}</div>
            ) : null}
          </div>
          <div className="col-md-6 form-group">
            <label>Arabic Canonical</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter ar canonical"
              name="ar_canonical"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.ar_canonical}
            />
            {formik.touched.ar_canonical && formik.errors.ar_canonical ? (
              <div className="error">{formik.errors.ar_canonical}</div>
            ) : null}
          </div>
          <div className="col-md-6 form-group">
            <label>Meta Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter meta title"
              name="meta_title"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.meta_title}
            />
            {formik.touched.meta_title && formik.errors.meta_title ? (
              <div className="error">{formik.errors.meta_title}</div>
            ) : null}
          </div>
          <div className="col-md-6 form-group">
            <label>Arabic Meta Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter ar meta title"
              name="ar_meta_title"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.ar_meta_title}
            />
            {formik.touched.ar_meta_title && formik.errors.ar_meta_title ? (
              <div className="error">{formik.errors.ar_meta_title}</div>
            ) : null}
          </div>


          <div className="col-md-6 form-group">
            <label>Key Words</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter keywords"
              name="keywords"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.keywords}
            />
            {formik.touched.keywords && formik.errors.keywords ? (
              <div className="error">{formik.errors.keywords}</div>
            ) : null}
          </div>
          <div className="col-md-6 form-group">
            <label>Arabic Key Words</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter ar keywords"
              name="ar_keywords"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.ar_keywords}
            />
            {formik.touched.ar_keywords && formik.errors.ar_keywords ? (
              <div className="error">{formik.errors.ar_keywords}</div>
            ) : null}
          </div>
          <div className="col-md-6 form-group">
            <label>Meta Description</label>
            <textarea
              type="text"
              className="form-control"
              placeholder="Enter meta description"
              name="meta_description"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.meta_description}
            />
            {formik.touched.meta_description &&
            formik.errors.meta_description ? (
              <div className="error">{formik.errors.meta_description}</div>
            ) : null}
          </div>
          <div className="col-md-6 form-group">
            <label>Arabic Meta Description</label>
            <textarea
              type="text"
              className="form-control"
              placeholder="Enter ar meta description"
              name="ar_meta_description"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.ar_meta_description}
            />
            {formik.touched.ar_meta_description &&
            formik.errors.ar_meta_description ? (
              <div className="error">{formik.errors.ar_meta_description}</div>
            ) : null}
          </div>
          <div
            className="d-flex align-items-center justify-content-center   w-100 "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Update" : <Spinner />}
            </button>
          </div>
          </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SeoHome;
